import React from 'react';
import { Office as OfficeType } from '../../law-firm/lawFirm.types';
import {
  ModalScrollableHeader,
  ModalScrollableContent,
  ModalScrollableContainer,
  ModalScrollableBody,
} from '../../components/modal';
import { OfficeList } from '../../entity/entity-lists/OfficeList';

type Props = {
  offices: OfficeType[];
  lawFirmName: string;
  onRequestClose: () => void;
  isOpen: boolean;
};

export class AllOfficesModal extends React.Component<Props> {
  static defaultProps = {
    onRequestClose: () => {},
    isOpen: false,
  };

  render() {
    const { offices, lawFirmName, onRequestClose, isOpen } = this.props;
    return (
      <ModalScrollableContainer isOpen={isOpen} onRequestClose={onRequestClose}>
        <ModalScrollableHeader
          title={`Tous les bureaux de ${lawFirmName}`}
          onClose={onRequestClose}
        />
        <ModalScrollableContent>
          <ModalScrollableBody>
            <OfficeList offices={offices} source="offices_modal_list" />
          </ModalScrollableBody>
        </ModalScrollableContent>
      </ModalScrollableContainer>
    );
  }
}
